import { AttributeMapping } from './creates';

// --- Component Identity ---
export const ICON_LOADER = 'progress_activity';

// --- CSS Classes ---
export const CLASS_WRAPPER = 'wrapper';
export const CLASS_SLOT = 'slot';
export const CLASS_ICON = 'icon';

// --- Attributes ---
export const ATTR_ROUNDED = 'rounded';
export const ATTR_LOADING = 'loading';
export const ATTR_DISABLED = 'disabled';
export const ATTR_VARIATION = 'variation'; // or 'data-variation'
export const ATTR_ICON = 'icon';
export const ATTR_ICON_POS = 'icon-pos';
export const ATTR_ICON_MARGIN = 'icon-margin';
export const ATTR_HIDE = 'hide';
export const ATTR_CLICK = 'click';

// --- States (Internal/CSS) ---
export const STATE_ICON = 'icon';
export const STATE_WITHOUT_ICON = 'without-icon';
export const STATE_ROUNDED = 'rounded';
export const STATE_LOADING = 'loading';
export const STATE_DISABLED = 'disabled';

// --- Events ---
export const EVENT_ICON = 'icon'; // Suffix
export const EVENT_VARIATION = 'variation'; // Suffix
export const EVENT_ICON_PROP_CHANGED = 'custom:icon.prop.changed';
export const EVENT_LOADING_STATE_CHANGED = 'custom:loading';

// --- Defaults & CSS Vars ---
export const DEFAULT_CSS_VAR_ICON_MARGIN =
  'var(--custom-bnum-button-icon-margin, 10px)';
export const ICON_PROP_POS = 'pos';
export const CSS_PROPERTY_ICON_MARGIN = '--bnum-button-icon-gap';

// --- Logic Helpers ---

// Definition for attribute mapping in Factory
export const BUTTON_ATTRIBUTE_MAP: ReadonlyArray<AttributeMapping> = [
  { prop: 'rounded', attr: ATTR_ROUNDED, isBool: true },
  { prop: 'loading', attr: ATTR_LOADING, isBool: true },
  { prop: 'icon', attr: `data-${ATTR_ICON}` },
  { prop: 'iconPos', attr: `data-${ATTR_ICON_POS}` },
  { prop: 'variation', attr: `data-${ATTR_VARIATION}` },
  { prop: 'hideOn', attr: `data-${ATTR_HIDE}` },
  { prop: 'iconMargin', attr: `data-${ATTR_ICON_MARGIN}` },
];

// Default Options for Factory
export const DEFAULT_BUTTON_OPTIONS = {
  text: '',
  iconPos: 'right', // Assumes 'right' is default in enum
  rounded: false,
  loading: false,
} as const;
